import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useTriggerSharePetitionModal } from '../useTriggerSharePetitionModal';

type UseSharePetitionButtonReturn = { actions: { handleShareClick: () => Promise<void> } };
export function useSharePetitionButton(): UseSharePetitionButtonReturn {
	const track = useTracking();
	const triggerSharePetitionModal = useTriggerSharePetitionModal();

	const handleShareClick = useCallback(async () => {
		void track('petition_manage_share_petition_click');
		await triggerSharePetitionModal();
	}, [track, triggerSharePetitionModal]);

	return {
		actions: { handleShareClick },
	};
}
